export default __webpack_public_path__ + "static/logo-73dcdaad0f2c656849bc0ee193091000.png";